import { render, staticRenderFns } from "./FooterTop.vue?vue&type=template&id=9bddd2a4&scoped=true&"
var script = {}
import style0 from "./FooterTop.vue?vue&type=style&index=0&id=9bddd2a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bddd2a4",
  null
  
)

export default component.exports